import * as React from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { DashboardHeader } from "./DashboardHeader";
import { ScanProvider } from "@/contexts/ScanContext";
import { SearchProvider } from "@/contexts/SearchContext";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <ScanProvider>
      <SearchProvider>
        <SidebarProvider defaultOpen={true} className="min-h-0 h-svh overflow-hidden">
          <AppSidebar />
          <SidebarInset className="min-h-0 overflow-hidden">
            <DashboardHeader />
            <div className="flex-1 min-h-0 overflow-auto">{children}</div>
          </SidebarInset>
        </SidebarProvider>
      </SearchProvider>
    </ScanProvider>
  );
}

export default DashboardLayout;
